var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode === 'item')?_c('funnels-item-view',{attrs:{"rawData":_vm.funnelData,"device":_vm.device,"infoData":_vm.infoData},on:{"onDeviceChange":function($event){_vm.device = $event}}}):_c('funnels-session-list',{attrs:{"rawData":_vm.funnelData,"device":_vm.device,"infoData":_vm.infoData,"onDeviceChange":_vm.device = _vm.$event}})
}
var staticRenderFns = []

export { render, staticRenderFns }